import { useMemo } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { useNumericOnlyKeyDown } from '../../../../../hooks/util/useNumericOnlyKeyDown';
import { KioskPhoneEntry } from './useKioskPhoneEntryForm';

export const useKioskPhoneEntryInput = ({
  register,
  onUserActivity,
}: {
  register: UseFormRegister<KioskPhoneEntry>;
  onUserActivity: () => void;
}) => {
  const numericOnlyKeyDownHandler = useNumericOnlyKeyDown();

  const inputFields: {
    name: keyof KioskPhoneEntry;
    flex: number;
    maxLength: number;
    minLength: number;
    placeholder?: string;
    onKeyDown: React.KeyboardEventHandler<HTMLInputElement>;
  }[] = useMemo(
    () => [
      {
        name: 'phone',
        flex: 1 / 2,
        maxLength: 4,
        minLength: 4,
        onKeyDown: numericOnlyKeyDownHandler,
      },
    ],
    [numericOnlyKeyDownHandler],
  );

  const inputConfigs = useMemo(
    () =>
      inputFields.map(
        ({ name, maxLength, minLength, flex, placeholder, onKeyDown }) => ({
          name,
          props: register(name, {
            maxLength,
            minLength,
            shouldUnregister: false,
          }),
          style: { flex },
          maxLength,
          minLength,
          placeholder,
          onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
            onKeyDown(e);
            onUserActivity();
          },
        }),
      ),
    [inputFields, register, onUserActivity],
  );

  return {
    inputConfigs,
  };
};
